export enum Environment {
  DEV = 'DEV',
  PROD = 'PROD',

}